<template>
  <div class="evidences">
    <div v-if="hasAccess">


    <header class="px-6 mx-4">
      <div class="flex justify-between">
        <div>
          <h2 class="text-xl font-semibold w-64 inline-block">
            Evidence Archive
          </h2>
          <div class="text-gray-500 pb-4">
            View current and historic evidence collection.
          </div>
        </div>
        <div>
          <Dropdown
            :options="typeDropdown"
            :selected="typeSelected"
            :title="'Media Type'"
            v-on:updateOption="updateSelectedType"
            style="min-width: 10rem"
          ></Dropdown>
        </div>
      </div>
    </header>

    <section class="w-95p mx-auto">
      <div
        style="width: 100%; text-align: center"
        class="spin-holder mt-4"
        v-if="loading"
      >
        <i class="spinner fa fa-spinner fa-spin"></i>
        <p>Loading Archive</p>
      </div>

      <div
        v-if="componentLoaded"
        class="px-auto grid grid-cols-8 lg:grid-cols-8 gap-2 gap-y-2 rounded pt-4 pb-2 z-index:99"
      >
        <div
          class="relative hover:opacity-75 focus:outline-none cursor-pointer"
          v-for="(item, index) in filteredEvidences"
          :key="index"
          @click="showEvidenceAsset(item)"
        >
          <div class="absolute w-full">
            <i
              v-if="hasNotes(item)"
              class="fas fa-comment float-right text-white p-2 text-lg"
            ></i>
          </div>

          <div class="max-w-sm rounded overflow-hidden shadow-lg z-index:999">
            <template v-if="item.media_type === 'video'">
              <evidencevideo
                :key="item.identifier"
                reference="'ref_'+index"
                :url="loadFile(item.media_url)"
                width="100%"
                height="100%"
                style="max-height: 110px !important"
              ></evidencevideo>
            </template>
            <template v-else>
              <evidenceimage
                :url="loadFile(item.media_url)"
                :key="item.identifier"
                reference="'ref_'+index"
                style="max-height: 110px !important"
              ></evidenceimage>
            </template>
            <div class="px-2 pt-2 pb-1 text-xs">
              <span class="text-green-600">{{
                parseCalendarSchoolYear(item)
              }}</span>
              <span v-if="isCurrentYear">
                -
                {{ parseDate(item.modified_date) }}<br />
                {{ item.course.name }}
              </span>
              <div
                class="text-xs mb-1 text-orange-400"
                v-html="getClassName(item)"
              ></div>
            </div>
          </div>
        </div>
      </div>

      <p class="ml-5 mt-6 text-sm" v-if="noResultsFound">
        We could not find any data for your given selection.
      </p>

      <Pagination
        v-if="componentLoaded"
        :total-pages="totalPages"
        :total="totalResultsCount"
        :current-page="currentPage"
        :has-more-pages="hasMorePages"
        :pageSize="pageSize"
        @pagechanged="showMore"
        class="mt-4 mb-12"
      >
      </Pagination>
    </section>

        </div>
   <div class="ml-4" v-else>
        <UpgradeContent :area="'Reporting'"></UpgradeContent>
      </div>

  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import { fileEvidenceMixin } from "@/mixins/file-EvidenceMixin.js";

import { EvidenceService, EvidenceFilter } from "@/services/evidence.service";
import { calendarYearList } from "@/assets/js/utils";

const evidenceimage = () => import("@/components/evidence/EvidenceImage.vue");
const evidencevideo = () => import("@/components/evidence/EvidenceVideo.vue");
const Pagination = () => import("@/components/helpers/Pagination.vue");
const EvidenceFilterModal = () =>
  import("@/components/helpers/EvidenceFilter.vue");
const Dropdown = () => import("@/components/Dropdown.vue");
const FilterBar = () => import("@/components/FilterBarNavigation.vue");
const UpgradeContent = () => import("@/components/upgrade/UpgradeContent.vue");

export default {
  name: "evidences",
  mixins: [fileEvidenceMixin],
  props: ["filterValues", "hasAccess"],
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
    }),
    componentLoaded() {
      return this.filteredEvidences.length > 0;
    },
    showMessage() {
      return this.msg != undefined && this.msg.length > 0;
    },
    hasMorePages() {
      return this.pagination.has_more === true;
    },
    totalResultsCount() {
      return this.pagination.total_count;
    },
    totalPages() {
      return this.pagination.total_pages;
    },
    typeDropdown() {
      var results = this.types;
      return results;
    },
    isCurrentYear() {
      return this.filterValues.calendar.current === true;
    },
    filteredEvidences() {
      var vm = this;
      return this.evidences.filter((item) => {
        var filtered = true;
        if (vm.typeSelected.value.length > 0) {
          filtered = item.media_type === vm.typeSelected.value;
        }

        return filtered;
      });
    },
    noResultsFound() {
      return !this.loading && this.evidences <= 0;
    },
    filterHasValues() {
      var value = this.filterValues;
      if (
        value.group != undefined ||
        value.years != undefined ||
        value.date != undefined ||
        (value.tags != undefined && value.tags.length > 2)
      ) {
        return true;
      }
    },
  },
  data() {
    return {
      loading: true,
      errored: false,
      filterIsVisible: false,
      evidences: [],

      lessons: [],

      page: 1,
      pageSize: 24,
      currentPage: 1,
      pagination: {},

      types: [
        { name: "All", value: "" },
        { name: "Images", value: "camera" },
        { name: "Videos", value: "video" },
      ],
      typeSelected: {},

      timeout: null,
    };
  },
  created() {
    this.folder = this.wordNumericValue(this.currentUser.schoolID);
    this.typeSelected = this.types[0];
  },
  mounted() {
    this.searchArchive();
  },
  watch: {
    $props: {
      handler: function (val, oldVal) {
        this.searchArchive();
      },
      deep: true,
    },
  },
  methods: {
    searchArchive() {
      this.loading = true;

      EvidenceService.getWithFilter(this.filterValues, this.page, this.pageSize)
        .then((response) => this.buildEvidences(response.data))
        .catch((err) => {
          console.log("evidences " + err);
          this.errored = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    alertDisplay() {
      this.$swal({
        title: "Please select more fields",
        text: "You must select a class or year group to complete the search.",
        type: "warning",
        showCancelButton: false,
        showCloseButton: true,
        showLoaderOnConfirm: true,
      });
    },
    buildEvidences(data) {
      // this.evidences = [...this.evidences, ...data.data]
      this.evidences = data.data;
      this.pagination = data.meta.pagination;
    },
    getClassName(evidence) {
      return evidence.inclass.length > 1
        ? evidence.inclass
        : '<span class="text-red-500 text-xs py-1 rounded"><i class="fas fa-exclamation-circle pr-2"></i>Class not set</span>';
    },
    parseDate(postedDate) {
      let date = moment(postedDate, "YYYY-MM-DD HH:mm:ss GMT Z");
      const timestamp = date.diff(Date.now(), "days");

      return timestamp < -7 ? date.format("DD/MM/YYYY") : date.fromNow();
    },
    parseCalendarSchoolYear(evidence) {
      let calendarYear = calendarYearList().find(
        (y) => y.value === evidence.calendar_schoolyear
      );
      if (calendarYear) {
        return calendarYear.short;
      }
    },
    hasNotes(evidence) {
      return evidence.notes != undefined && evidence.notes.length > 0;
    },
    loadFile(path) {
      return this.folder + "/" + path;
    },
    getYearName(yearId) {
      let found = this.years.find((y) => y.id === yearId);
      return found === undefined ? "N/A" : "Y" + found.letter;
    },
    updateSelectedType(type) {
      this.typeSelected = type;
    },
    showMore({ page, size }) {
      this.page = page;
      this.currentPage = page;
      this.pageSize = size;
      this.searchArchive();
      window.scrollTo(0, 0);
    },
    showEvidenceAsset(item) {
      this.evidenceAsset = item;
      this.$router.push({
        name: "EvidenceView",
        params: {
          evidence: item,
          readonly: !this.isCurrentYear,
          course: this.evidenceAsset.course,
          closePath: "/reports/evidences"
        },
      });
    },
  },
  components: {
    evidenceimage,
    evidencevideo,
    Pagination,
    EvidenceFilterModal,
    Dropdown,
    UpgradeContent
  },
};
</script>

<style>
i.icon {
  font-size: 18px;
  padding-left: 4px;
  padding-top: 4px;
}
</style>
